import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import NewInvoice from "./NewInvoice";
import InvoiceService from "../../services/invoice.service";
import { Link } from "react-router-dom";

const InvoicePreview = () => {
  const location = useLocation();
  const { isPaid, invno } = location.state;

  const [invoiceDetails, setInvoiceDetails] = useState([]);

  const [otherInvDetails, setOtherInvDetails] = useState({
    invoiceNo: "",
    invoiceDate: "",
    totalAmt: "",
    totalAmtWords: "",
  });

  useEffect(() => {
    generateInvoice();
  }, []);

  const generateInvoice = () => {
    const data = {
      invno: invno,
    };
    InvoiceService.genInvoice(data)
      .then((resp) => {
        // console.log(resp.data);
        setInvoiceDetails(resp.data);
        setOtherInvDetails({
          invoiceNo: resp.data[0].invoive_no,
          invoiceDate: resp.data[0].created_on,
          totalAmt: resp.data[0].Total_amount,
          totalAmtWords: resp.data[0].amtinword,
        });
      })
      .catch();
  };

  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-xl-12 col-lg-12">
          <div className="box-outer right">
            <div className="box-inner">
              <div className="search-bar form-flex">
                <div className="action-flex bck-invoice">
                  <div className="courses-act">
                    <Link
                      to={isPaid ? "/PaidInvoice" : "/PendingInvoice"}
                      className="action-item"
                    >
                      <div>
                        <span>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="14"
                            height="14"
                            viewBox="0 0 19.379 19.382"
                          >
                            <g
                              id="left-arrow-in-circular-button-black-symbol"
                              transform="translate(-0.6 511.567)"
                            >
                              <path
                                id="Path_13057"
                                data-name="Path 13057"
                                d="M9.381-511.546A9.911,9.911,0,0,0,4.162-509.4a11.83,11.83,0,0,0-1.457,1.468,10.165,10.165,0,0,0-1.878,3.88A8.145,8.145,0,0,0,.6-501.873a8.145,8.145,0,0,0,.228,2.181,10.088,10.088,0,0,0,1.931,3.945,11.828,11.828,0,0,0,1.468,1.457,10.164,10.164,0,0,0,3.88,1.878,8.146,8.146,0,0,0,2.181.228,8.146,8.146,0,0,0,2.181-.228,10.541,10.541,0,0,0,3.141-1.339A9.712,9.712,0,0,0,19-497.606a9.626,9.626,0,0,0,.914-2.94,12.941,12.941,0,0,0,0-2.655,9.626,9.626,0,0,0-.914-2.94,9.19,9.19,0,0,0-1.889-2.625,9.01,9.01,0,0,0-2.553-1.813,9.581,9.581,0,0,0-2.9-.91A14.607,14.607,0,0,0,9.381-511.546Zm1.1,5.618a.61.61,0,0,1,.25.766c-.03.068-.622.69-1.328,1.392L8.126-502.5l3.315.019c3.277.019,3.319.019,3.421.1a.536.536,0,0,1,.262.508.536.536,0,0,1-.262.508c-.1.08-.144.08-3.421.1l-3.315.019L9.4-499.977c.706.7,1.3,1.324,1.328,1.392a.607.607,0,0,1-.77.808c-.14-.053-3.683-3.588-3.751-3.744a1.386,1.386,0,0,1-.015-.683c.053-.133,3.581-3.679,3.736-3.751A.637.637,0,0,1,10.477-505.928Z"
                                transform="translate(0 0)"
                              />
                            </g>
                          </svg>
                        </span>
                        &nbsp;&nbsp;
                        <span>Back</span>
                      </div>
                    </Link>
                  </div>
                </div>
              </div>
              <div className="cert-flex">
                <NewInvoice
                  invoiceDetails={invoiceDetails}
                  otherInvDetails={otherInvDetails}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InvoicePreview;
